import { Link } from 'react-router-dom';

const TRUST_LINE = ['Secure by design', 'Data sovereignty', 'Enterprise support', 'Hybrid-ready infrastructure'];

const HERO_IMAGE = 'https://customer-assets-lqy194kg.emergentagent.net/job_4b2a553d-5925-4a02-872f-19eeccf7b117/artifacts/0lzfbiuw_image.jpeg';

export const HeroSection = () => (
  <section data-testid="hero-section" className="relative overflow-hidden min-h-[92vh] flex items-center">
    <img
      src={HERO_IMAGE}
      alt="Independence Arch and the Accra skyline at dusk, Ghana"
      fetchPriority="high"
      className="absolute inset-0 w-full h-full object-cover kenburns-img"
    />
    <div className="absolute inset-0 bg-gradient-to-l from-[#0B0524]/[0.92] via-[#120836]/[0.68] to-[#120836]/[0.28]" />
    <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#120836] to-transparent" />

    <div className="max-w-[1280px] mx-auto px-6 lg:px-10 pt-36 lg:pt-40 pb-20 lg:pb-28 relative z-10 w-full">
      <div className="max-w-[680px] lg:ml-auto">
        <p className="text-[#F29B3D] text-xs font-bold uppercase tracking-[0.22em] mb-6" data-testid="hero-eyebrow">
          Built for Africa. Deployable Anywhere.
        </p>

        <h1
          data-testid="hero-headline"
          className="text-white text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.03em] leading-[1.06] mb-6"
        >
          Sovereign cloud,
          <span className="block mt-1">
            built for Africa.
          </span>
        </h1>

        <p className="text-[#CBD5E1] text-base lg:text-lg leading-relaxed max-w-[560px] mb-9">
          Secure compute, storage, networking, backup and cybersecurity — engineered
          by Africans, for Africa, deployable in any jurisdiction. One platform
          for enterprises, governments and critical infrastructure.
        </p>

        <div className="flex flex-wrap items-center gap-4 mb-9">
          <Link
            to="/cloud-access"
            data-testid="hero-request-access"
            className="bg-[#F29B3D] hover:bg-[#DD8226] text-white font-semibold text-[15px] px-7 py-3.5 rounded-[10px] transition-colors duration-200"
          >
            Request Cloud Access
          </Link>
          <Link
            to="/contact"
            data-testid="hero-talk-architect"
            className="border border-white/25 hover:border-[#F29B3D]/60 bg-white/[0.06] backdrop-blur-sm text-white font-medium text-[15px] px-7 py-3.5 rounded-[10px] transition-colors duration-200"
          >
            Talk to a Cloud Architect
          </Link>
        </div>

        <p data-testid="hero-trust-line" className="text-[#9DB2C8] text-[13px] flex flex-wrap items-center gap-x-2 gap-y-1">
          {TRUST_LINE.map((t, i) => (
            <span key={t} className="flex items-center gap-2">
              {i > 0 && <span className="text-[#F29B3D]">·</span>}
              {t}
            </span>
          ))}
        </p>
      </div>
    </div>
  </section>
);
